var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ShowChip)?_c('div',{staticClass:"container"},[_c('i',{class:['chips', 'text-ibm-plex-sans', _vm.color, _vm.getChipType()]},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" "),(_vm.showButton)?_c('button',{staticClass:"button",on:{"click":_vm.showChip}},[_c('ChipsCancel',{attrs:{"color":_vm.color}})],1):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }